LoginInAlcmeonController.$inject = ['$scope', 'company', 'LoginFactory', '$uibModal', '$translate', '$stateParams'];
export function LoginInAlcmeonController($scope, company, LoginFactory, $uibModal, $translate, $stateParams) {

  $scope.submit = submit;

  init();

  function submit() {
    LoginFactory.doLogin(company.id, $scope.email, $scope.password, $stateParams.destState, $stateParams.destUrl)
      .then(
        function () {
          // nothing to do in case of success (login.service takes care of redirecting to the correct page)
        },
        function (response) {
          if (response && response.status === 307 && response.data?.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else if (response.data?.error) {
            $uibModal.open({
              animation: false,
              template: require('./login.error.html'),
              resolve: {
                email: function () {
                  // extract email variable from parent scope
                  return $scope.email;
                }
              },
              controller: ['$scope', 'email', function ($scope, email) {
                $scope.error = response.data.error;
                $scope.email = email;
              }]
            });
          }
        }
      );
  }

  function init() {
    $scope.email = '';
    $scope.password = '';
    if ($stateParams.errorMessageKey) {
      $scope.errorMessage = $translate.instant($stateParams.errorMessageKey);
    }
  }

}
